import { LoadScriptProps } from '@react-google-maps/api';

export const loadScriptProps: LoadScriptProps = {
  googleMapsApiKey: 'AIzaSyBU6_B0UiI7ca3RSWZOqCu3fM2vxv3chDc',
  language: 'en',
  region: 'us',
  libraries: ['places'],
  id: 'script-loader',
};
